import { CSSProperties, memo } from 'react';
import {
  Button,
  ButtonProps,
  Media,
  SVG,
} from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';

type UploadButtonProps = {
  mode?: Extract<ButtonProps['mode'], 'accent' | 'additional'>;
  isNoFiles?: boolean;
  maxFiles?: number;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
  style?: CSSProperties;
  className?: string;
};

export const UploadButton = memo(
  ({
    mode = 'additional',
    isNoFiles,
    maxFiles,
    onSuccess,
    onError,
    style,
    className,
  }: UploadButtonProps) => {
    return (
      <Media.Uploader
        maxFiles={maxFiles}
        asChild
        onError={onError}
        onSuccess={onSuccess}
      >
        <Button
          leftIcon={<SVG src={Icons.Plus} />}
          mode={mode}
          size="l"
          className={className}
          style={style}
        >
          {isNoFiles ? 'Прикрепить фото' : 'Добавить ещё'}
        </Button>
      </Media.Uploader>
    );
  }
);
